import { formValidation } from "./utils";

$(document).ready(function(){
    var $form = $('#edit-user');
    if(!$form.length){
        return;
    }
    
    var $avatarField = $('#profile-avatar');
    var $avatarFileInfo = $form.find('.avatar-info');
    var $cancelUpload = $form.find('.cancel-upload');
    
    // On file change - show file name under Upload button
    $avatarField.on('change', function(e){
        if(this.files && this.files.length){
            var file = this.files[0];
            $avatarFileInfo.find('.no-file').addClass('d-none');
            $avatarFileInfo.find('.file-name').html(file.name);
            $avatarFileInfo.find('.file-description').removeClass('d-none');
        }
        else {
            $avatarFileInfo.find('.file-description').addClass('d-none');
            $avatarFileInfo.find('.file-name').html('');
            $avatarFileInfo.find('.no-file').removeClass('d-none');
        }
    });
    
    // Reset selected file
    $cancelUpload.click(function(e){
        $avatarField.val('').trigger('change');
        
        e.preventDefault();
        return false;
    });
    
    // Form validation
    $form.submit(formValidation);
    
    // Disable duplicate submission on page reload
    if($form.hasClass('was-submitted') && window.history.replaceState){
        window.history.replaceState( null, null, window.location.href );
    }
    
});